module.exports = __webpack_public_path__ + "img/59_12.bec13820.png";